import React, { useState, useLayoutEffect } from "react";
import { Link } from "gatsby";
import styled from "styled-components";
import useAnimationFrame from "../../hooks/useAnimationFrame";
import mabaniNavLinks from "./mabaniNavLinks";

const MabaniNav = ({ currentTitle }) => {
  const [currentScrollPos, setCurrentScrollPos] = useState(0);
  const [prevScrollPos, setPrevScrollPos] = useState(0);
  const [visible, setVisible] = useState(true);

  useAnimationFrame( deltaTime => {
    setCurrentScrollPos(currentScrollPos => window.pageYOffset);
  })

  useLayoutEffect(() => {
    if ( prevScrollPos < currentScrollPos && currentScrollPos - prevScrollPos > 100) {
      setPrevScrollPos(currentScrollPos);
      setVisible(false)
    }
    else if ( currentScrollPos < prevScrollPos && prevScrollPos - currentScrollPos > 100) {
      setPrevScrollPos(currentScrollPos);
      setVisible(true)
    }
    else if ( currentScrollPos < 100 ) {
      setVisible(true);
    }
  }, [currentScrollPos]);

  return (
    <>
      <StyledNav className={visible ? "is-visible" : "is-hidden"}>
        <div>
          {mabaniNavLinks.map(({to, label}, index) => (
            <StyledLink 
              as={Link} 
              to={to} 
              title={label}
              activeClassName="is-active"
              key={`nav-${index}`}
            >{label}</StyledLink>
          ))}
        </div>
      </StyledNav>
    </>
  )
}
export default MabaniNav;

const StyledLink = styled.a`
  position: relative;
  z-index: 1;
  line-height: 1;
  transition: opacity 0.3s ease;
  .can-hover &:not(.is-active):hover,
  &:not(.is-active):active {
    opacity: 0.7;
  }
  &.is-active {
    cursor: default;
    opacity: 0.5;
  }
  font-size: 0.9375em;
  font-weight: 500;
  &:not(:last-of-type) {
    margin-right: 2em;
  }

`;


const StyledNav = styled.nav`
  position: sticky;
  z-index: 99;
  top: calc(var(--navbar-height) - 1px);
  > div {
    padding: 1.25em 0;
    display: flex;
  justify-content: space-between;
  }
  background-color: var(--theme-background-dark);
  color: var(--theme-text-against-dark);
  //margin-top: calc(-1 * var(--navbar-height));
  transform: translate3d(0,0,0);
  transition: transform 0.6s ease;
  &.is-hidden {
    transform: translate3d(-0,calc(-100% - var(--navbar-height) - 1px),0);
    transition: transform 0.5s ease;
  }
  &::before {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    left: 50%;
    margin-left: -50vw;
    width: 100vw;
    background: inherit;
    z-index: -1;
    box-shadow: inset 0 -1px 0 rgba(255,255,255,0.1);
  }
  @media ( max-width: 60em ) {
    width: 100vw;
    margin-left: calc(-1 * var(--gutter));
    > div {
      overflow: auto;
      white-space: nowrap;
      padding-right: var(--gutter);
      padding-left: var(--gutter);
    }
  }
`;


